import { FunctionComponent } from "react";
import { StyledButton } from "./big-button.styles";

interface BigButtonProps {
  children: any;
  onClick: () => void;
  disabled?: boolean;
  style?: any;
  type?: "button" | "submit" | "reset";
}

const BigButton: FunctionComponent<BigButtonProps> = ({
  children,
  onClick,
  disabled = false,
  style = {},
  type = "button",
}) => {
  return (
    <StyledButton
      type={type}
      style={style}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </StyledButton>
  );
};

export default BigButton;
